let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8i46r")).then(() => parcelRequire('xl1rO'));